// extracted by mini-css-extract-plugin
export default {"button":"jr-z","reviewSort":"kr-z"};